export enum CommissionBaseType {
  JOB_SUBTOTAL = 'JOB_SUBTOTAL',
  LINE_ITEM_TOTAL = 'LINE_ITEM_TOTAL',
  JOB_TOTAL = 'JOB_TOTAL',
  LINE_ITEM_PROFIT = 'LINE_ITEM_PROFIT',
  PAID_AMOUNT = 'PAID_AMOUNT',
  NET_PAID_AMOUNT = 'NET_PAID_AMOUNT',
  INVOICE_TOTAL = 'INVOICE_TOTAL',
  NET_MARGIN = 'NET_MARGIN',
  GROSS_MARGIN = 'GROSS_MARGIN'
}

export const CommissionBaseTypeLabels: Record<CommissionBaseType, string> = {
  [CommissionBaseType.JOB_SUBTOTAL]: 'Job subtotal',
  [CommissionBaseType.LINE_ITEM_TOTAL]: 'Line item total',
  [CommissionBaseType.JOB_TOTAL]: 'Job total',
  [CommissionBaseType.LINE_ITEM_PROFIT]: 'Line item profit',
  [CommissionBaseType.PAID_AMOUNT]: 'Paid amount',
  [CommissionBaseType.NET_PAID_AMOUNT]: 'Net paid amount',
  [CommissionBaseType.INVOICE_TOTAL]: 'Invoice total',
  [CommissionBaseType.NET_MARGIN]: 'Net margin',
  [CommissionBaseType.GROSS_MARGIN]: 'Gross margin before external referral'
};

export const CommissionBaseHelperText: Record<CommissionBaseType, string> = {
  [CommissionBaseType.JOB_SUBTOTAL]: 'Job subtotal = Line item total - Discount',
  [CommissionBaseType.LINE_ITEM_TOTAL]: 'Line item total = Total price of all line items',
  [CommissionBaseType.JOB_TOTAL]:
    'Job total = Job subtotal + Service charges (Taxes and service fees are not included)\n' +
    'Same calculation as:\nJob total = Invoice total - Service fee - Taxes',
  [CommissionBaseType.LINE_ITEM_PROFIT]: 'Line item profit = Total line item price - Total line item costs',
  [CommissionBaseType.PAID_AMOUNT]:
    'Paid amount = Total amount paid by customer (including tips)\n' + 'Only applicable when an invoice is paid.',
  [CommissionBaseType.NET_PAID_AMOUNT]:
    'Net paid amount = Total customer paid amount - ScanPay fees\n' + 'Only applicable when an invoice is paid.',
  [CommissionBaseType.INVOICE_TOTAL]:
    'Invoice total = Total invoice amount\n' +
    'Same calculation as:\n' +
    'Invoice total = Line item total - Discount + Service fee + Taxes + Service charges',
  [CommissionBaseType.NET_MARGIN]:
    'Net margin = Paid amount - ScanPay fees - Costs & Expenses - External company referral\n' +
    'Same calculation as:\n' +
    // eslint-disable-next-line max-len
    'Net margin = Paid amount (including tips) - ScanPay fees - Total unit costs - Total expenses (= Company + Team expenses) - External company referral',
  [CommissionBaseType.GROSS_MARGIN]:
    'Gross margin before external referral = Paid amount - ScanPay fees - Costs & Expenses\n' +
    'Same calculation as:\n' +
    // eslint-disable-next-line max-len
    'Gross margin before external referral = Paid amount - ScanPay fees - Total unit costs - Total expenses (= Company + Team expenses)'
};

export enum CommissionType {
  PERCENTAGE = 'PERCENTAGE',
  ABSOLUTE = 'ABSOLUTE'
}

export enum CommissionStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum CommissionRuleConditionOp {
  IS_ANY_OF = 'IS_ANY_OF',
  IS_NONE_OF = 'IS_NONE_OF'
}

export enum CommissionRuleConditionIfDisplay {
  LEAD_SOURCE = 'Lead source',
  EXTERNAL_COMPANY_ID = 'External company',
  PAYMENT_METHOD = 'Payment method'
}

export enum CommissionRuleConditionIf {
  LEAD_SOURCE = 'LEAD_SOURCE',
  EXTERNAL_COMPANY_ID = 'EXTERNAL_COMPANY_ID',
  PAYMENT_METHOD = 'PAYMENT_METHOD'
}

export enum CommissionRuleConditionOpDisplay {
  IS_ANY_OF = 'is any of',
  IS_NONE_OF = 'is none of'
}

export enum CommissionRuleStatusDisplay {
  ACTIVE = 'Active',
  ARCHIVED = 'Archived'
}

export const CommissionStatusFilterOptions = [
  { id: CommissionStatus.ACTIVE, name: 'Active' },
  { id: CommissionStatus.ARCHIVED, name: 'Archived' }
];

export const CommissionBaseTypeFilterOptions = Object.values(CommissionBaseType).map(base => ({
  id: base,
  name: CommissionBaseTypeLabels[base]
}));

export const CommissionRuleConditionIfFilterOptions = [
  { id: '1', name: 'None' },
  { id: CommissionRuleConditionIf.LEAD_SOURCE, name: CommissionRuleConditionIfDisplay.LEAD_SOURCE },
  { id: CommissionRuleConditionIf.EXTERNAL_COMPANY_ID, name: CommissionRuleConditionIfDisplay.EXTERNAL_COMPANY_ID },
  { id: CommissionRuleConditionIf.PAYMENT_METHOD, name: CommissionRuleConditionIfDisplay.PAYMENT_METHOD }
];
